import { Routes, Route } from 'react-router-dom';
import { Taskbar } from './components/taskbar/taskbar';
import { HomePage } from './pages/home/home';
import { BlogIndexPage } from './pages/blog-index/blog-index';
import { BlogPostPage } from './pages/blog-post/blog-post';
import { AdminPage } from './pages/admin/admin';
import { NotFoundPage } from './pages/not-found/not-found';

const GITHUB_URL = 'https://github.com/gardner-nick';
const LINKEDIN_URL = 'https://www.linkedin.com/in/nicholas-gardner-7b588a105/';

function App() {
  return (
    <div className="min-h-dvh bg-bg text-fg">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Taskbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <footer className="border-t border-border">
        <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-3 px-5 py-8 sm:flex-row">
          <p className="font-mono text-sm text-muted">
            <span className="text-accent">$</span> echo &quot;built by Nick Gardner&quot;
          </p>
          <div className="flex items-center gap-5 font-mono text-sm">
            <a href={GITHUB_URL} target="_blank" rel="noreferrer" className="link-accent">
              GitHub
            </a>
            <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="link-accent">
              LinkedIn
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
